import styled from "@emotion/styled";

const LeftPanelWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  color: var(--cms-text-primary);
  height: 100%;
  overflow-y: auto;
  width: 292px;
  border-right: 1px solid var(--cms-sidebar-border);
  background: var(--cms-sidebar-bg);
  align-items: flex-start;
  flex-direction: column;
  box-shadow: inset -1px 0 0 var(--cms-sidebar-inset-shadow);
  padding: 14px 10px 20px;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(148, 163, 184, 0.5);
    border-radius: 999px;
  }
`;

const PanelMenu = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;

  .menu-group {
    border: 1px solid var(--cms-sidebar-group-border);
    border-radius: 14px;
    background: var(--cms-sidebar-group-bg);
    box-shadow: var(--cms-sidebar-group-shadow);
    padding: 8px 8px 6px;
    backdrop-filter: blur(2px);
  }
`;

const PanelMenuItem = styled.li`
  list-style: none;

  &.group-title {
    margin: 0;
    padding: 2px 10px 7px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    font-size: 10px;
    color: var(--cms-sidebar-group-title);
  }

  &.clickable {
    margin-top: 2px;
    padding: 0;

    button {
      display: flex;
      align-items: center;
      width: 100%;
      min-height: 36px;
      padding: 8px 12px;
      border: 1px solid transparent;
      border-radius: 10px;
      background-color: transparent;
      cursor: pointer;
      font-size: 16px;
      font-weight: 600;
      text-align: left;
      color: var(--cms-sidebar-item-text);
      transition: all 0.2s ease;
    }

    button:hover {
      background: var(--cms-sidebar-item-hover-bg);
      color: var(--cms-sidebar-item-hover-text);
      transform: translateX(1px);
    }

    button:focus-visible {
      outline: 2px solid var(--cms-focus-ring);
      outline-offset: 1px;
    }
  }

  &.clickable.active {
    button {
      color: var(--cms-sidebar-item-active-text);
      border-color: var(--cms-sidebar-item-active-border);
      background: var(--cms-sidebar-item-active-bg);
      box-shadow: var(--cms-sidebar-item-active-shadow);
    }
  }
`;

const StyledProfileImageWrapper = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
  }
`;

const StyledLoginPenalLoadingIcon = styled.img`
  width: 35px;
`;

const StyledLoginPenal = styled.div`
  display: flex;
  font-size: 16px;
  margin-right: 15px;
  padding: 40px 30px;
  a {
    color: #bfc7d6;
    text-underline-offset: 2px;
  }
`;

const StyledLoginPenalItem = styled.div`
  margin-right: 20px;
  display: inline-block;
`;

export {
  LeftPanelWrapper,
  PanelMenu,
  PanelMenuItem,
  StyledProfileImageWrapper,
  StyledLoginPenalLoadingIcon,
  StyledLoginPenal,
  StyledLoginPenalItem,
};
